import { CSSObject } from '@emotion/core';

import { themeColor } from '@scripts/themes/cssVars';

export const desktopFooterStyles: CSSObject = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    padding: '24px 30px',
    borderRadius: '0 0 20px 20px',
    borderTop: `1px solid ${themeColor.border}`,
    width: '100%',
};

export const mobileFooterStyles: CSSObject = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '24px 16px 32px',
    borderTop: `1px solid ${themeColor.middleBackground}`,
    width: '100%',
    height: '128px',
    flexShrink: 0,
    backgroundColor: themeColor.white,
};

export const cancelButtonStyles: CSSObject = {
    width: 'auto',
    ':hover': {
        transition: '0.2s',
    },
};

export const desktopSubmitButtonStyles: CSSObject = {
    width: 'auto',
    backgroundColor: themeColor.orange,
    borderRadius: '16px',
    ':hover': {
        backgroundColor: themeColor.orangeHover,
    },
};

export const mobileSubmitButtonStyles: CSSObject = {
    width: '100%',
    height: '40px',
    padding: '10px 0',
    backgroundColor: themeColor.orange,
    ':hover': {
        backgroundColor: themeColor.orangeHover,
    },
};

export const clearButtonStyles: CSSObject = {
    width: '100%',
    height: '40px',
    padding: '10px 0',
};
